import { render } from "./FooterSection.vue?vue&type=template&id=6678be7b&ts=true"
import script from "./FooterSection.vue?vue&type=script&lang=ts"
export * from "./FooterSection.vue?vue&type=script&lang=ts"

import "./FooterSection.vue?vue&type=style&index=0&id=6678be7b&lang=scss"

import exportComponent from "/Users/rboss/repos/TRENZ/Kunden/KaRa/Mockup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__